"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileLogWebsocketClient = void 0;
const websocket_client_1 = require("./websocket.client");
class MobileLogWebsocketClient extends websocket_client_1.WebsocketClient {
    constructor(liveApiUrl, loginUrl, query) {
        super(`${liveApiUrl}/mobile-log`, loginUrl, query);
    }
    streamLogs() {
        return super.stream('mobile-log');
    }
}
exports.MobileLogWebsocketClient = MobileLogWebsocketClient;
//# sourceMappingURL=mobile-log-websocket.client.js.map